<template>
  <div
    class="tw-bg-[#ffffff] !tw-w-[220px] tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1] tw-gap-[25px]"
  >
    <div
      class="tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px]"
    >
      {{
        getComponentUiText(
          "app-component-assessment-display-options-heading-display-options-1",
        )
      }}
    </div>
    <div
      v-for="(item, index) in listOption"
      :key="index"
      class="tw-flex tw-justify-between tw-items-center tw-w-full"
      :data-cy="`${item.dataCy}`"
    >
      <span
        class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[120%] tw-font-Poppins"
      >
        {{ item.title }}
      </span>
      <ToggleSwitch
        :is-checked="item.value"
        :data-cy="`assessment-display-options-${index}`"
        :data-status="item.value ? 'checked' : 'unchecked'"
        color="#2573E9"
        @update:is-checked="(value) => item.action(value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import ToggleSwitch from "../common/toggleSwitch.vue";
import { getComponentUiText } from "@/utils/utilities";
interface option {
  title: string;
  value: boolean;
  action: (value: boolean) => void;
  dataCy: string;
}
defineProps({
  listOption: {
    type: Array as PropType<option[]>,
    required: true,
    default: () => [],
  },
});
</script>

<style scoped lang="scss">
.tw-font-Poppins {
  font-family: Poppins;
}
</style>
